import {Component, OnInit} from '@angular/core';
import { FormControl, FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {ClearPendingPaymentDialogResult,} from '@portal-workspace/grow-shared-library';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {UntilDestroy} from '@ngneat/until-destroy';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    templateUrl: './clear-pending-payment.dialog.html',
    styleUrls: ['./clear-pending-payment.dialog.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, FlexModule, MatButtonModule]
})
export class ClearPendingPaymentDialog implements OnInit {
  formGroup: FormGroup<{
    responseFile: FormControl<string |null>,
  }>;
  formControlResponseFile: FormControl<string |null >;

  constructor(
              private matDialogRef: MatDialogRef<ClearPendingPaymentDialog, ClearPendingPaymentDialogResult>,
              private formBuilder: FormBuilder) {        
    this.formControlResponseFile = formBuilder.control(null);
    
    this.formGroup = formBuilder.group({
      responseFile: this.formControlResponseFile,
    });
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
  }

  onCancel() {
    this.matDialogRef.close();
  }
  onSubmit() {
      this.matDialogRef.close({
        responseFile: this.formControlResponseFile.value
      });
    }
  }
